import { Component } from '@angular/core';

import { ModalService } from '../../modules/modal/modal.service';

import { Message } from '../../models';

@Component({
  selector: 'message-modal',
  templateUrl: './message-modal.component.html',
})
export class MessageModalComponent {

  data: Message;
  success: Function;

  constructor(
    private _modalService: ModalService
  ) {}

  onOkClicked(): void {
    if (this.success) {
      this.success();
    }
    this._modalService.closeModal();
  }

}
